@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
<div class="content">
  <div class="inputRow">
    <div class="inputWrapper">
      <label class="instructionLabel">Please select a rep office for valid LIST pricing</label>
    </div>
    <span class="inputWrapper">
      <label class="inputLabel">Rep Office:</label>
      <select class="selectionInput" [disabled]="isBusy()" [(ngModel)]="sellingOrgId" (ngModelChange)="repOfficeChanged()">
        <option [value]="''">Please Select</option>
        @for (rep of repOffices(); track rep) {
          <option [value]="rep.code">{{ rep.description }}</option>
        }
      </select>
    </span>
    @if (isRepSelected()) {
      <span class="inputWrapper">
        <label class="priceListLabel">Price List:</label>
        <label class="priceListValueLabel">{{getSelectedPriceListId()}}</label>
      </span>
    }
  </div>
  @if (isRepSelected()) {
    <div class="inputRow">
      <span class="inputWrapper">
        <label class="inputLabel">Selected Product:</label>
        <select class="selectionInput" [disabled]="isBusy()" [(ngModel)]="selectedProductId"
          (ngModelChange)="productChanged()">
          <option [value]="''">Please Select</option>
          @for (product of allProducts(); track product) {
            <option [value]="product.productId">{{ product.productId }}</option>
          }
        </select>
      </span>
    </div>
  }
  @if (isUnitSelected()) {
    <div class="inputRow">
      <div class="configurationInputs">
        @for (group of pricingGroups; track group) {
          <div class="configurationGroup">
            @if (group.getSelections().length > 0) {
              <div>
                <div class="groupHeader">{{group.groupName}}</div>
                <div class="inputRow">
                  @for (selection of group.getSelections(); track selection) {
                    <app-configuration-input [invalidSelections]="invalidSelections()"
                      [isBusy]="isBusy()" [selection]="selection"
                      (booleanValueChanged)="toggleBooleanValue($event)"
                      (selectionValueChanged)="userSelectionChanged($event)">
                    </app-configuration-input>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="skusAndPrices">
        @if (hasMessages()) {
          <div class="messageButtonWrapper">
            <button matButton="elevated" class="messagesButton" (click)="showMessagesDialog()">Messages</button>
          </div>
        }
        @if (configurationData()) {
          <div class="pricingDataWrapper">
            <div class="inputRow">
              <label class="leadTimeLabel">Best Lead Time:</label>
              <label class="leadTimeValueLabel">{{ configurationData().bestLeadTime.code }}</label>
            </div>
            <div class="skuList">
              @for (sku of configurationData().skus; track sku) {
                <div class="skuInputRow">
                  <label class="skuNameLabel">{{ sku.description }}</label>
                  <label class="skuPriceLabel">{{ sku.price | currency: 'USD' }}</label>
                </div>
              }
            </div>
            <div class="skuTotalRow">
              <label class="totalPriceLabel">Total List Price:</label>
              <label class="totalPriceValueLabel">{{getTotalPrice() | currency: 'USD'}}</label>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
